/* eslint-disable consistent-return */
import React from 'react';
import translate from '../../../../utils/translations';
import {edap, toast} from '../../../molecules/baseline/baseline';
import {
    INVITE_GUESTS_SENT,
    REMOVE_GUEST,
    SEND_INVITE,
    TRAVELLER_ACTIVITY,
} from '../constants';
import {isExperimentBucketed} from '../../../../utils/experimentBucket';

export const guestsAlteredToast = ({
    action,
    addToast,
    numberInvited,
    resend,
    translations,
}) => {
    const inviteSentToast = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'widget.trip.gog.copy.update.success.toast',
        {count: numberInvited}
    );
    const addGueststoast = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.toast.add',
        {count: numberInvited}
    );
    const resendEmailText = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.toast.email.resend'
    );
    const guestRemovedText = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.remove.guests.toast'
    );
    const removedFromTripText = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.add.guests.toast.remove'
    );

    const experimentEvaluation = isExperimentBucketed(
        'vrbo_stx_gog_widget_copy_update'
    );

    const triggerAddToast = (message) => {
        const toastProps = {
            autoClose: 6000,
            closeOnClick: true,
            type: 'inverse',
        };
        addToast(
            toast(<h3 className="GuestsOfGuest__toast">{message}</h3>, {
                ...toastProps,
            })
        );
    };
    const inviteText = experimentEvaluation ? inviteSentToast : addGueststoast;
    if (action === SEND_INVITE) {
        if (!resend) {
            edap().push({
                name: 'generic.event',
                data: {
                    eventcategory: TRAVELLER_ACTIVITY,
                    eventaction: INVITE_GUESTS_SENT,
                    eventlabel: numberInvited,
                },
            });
            triggerAddToast(inviteText);
        } else {
            triggerAddToast(resendEmailText);
        }
    } else if (action === REMOVE_GUEST) {
        return experimentEvaluation
            ? triggerAddToast(guestRemovedText)
            : triggerAddToast(removedFromTripText);
    }
};
